import CodeView from 'src/components/CodeView';
import defaultChatBox from 'src/examples/ChatBox/default';
import fullWidthChatBox from 'src/examples/ChatBox/fullWidth';
import * as React from 'react';
export default {
  CodeView,
  defaultChatBox,
  fullWidthChatBox,
  React
};